import PayloadModel from "model/_payload/payload.schema";
import StatsModel from "model/dashboard/stats.schema";
import AffiliatesModel from "model/dashboard/affiliates.schema";
import ProductsModel from "model/dashboard/products.schema";
import { createBaseApi } from "../baseApi";

export const dashboardApi = createBaseApi("dashboards", "/dashboards").injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    // STATS
    getDashboardStats: builder.query({
      // Transform dates before they enter the store
      query: (value) => {
        const payload = PayloadModel.modelToJson(value);
        return {
          url: "/overview",
          method: "GET",
          params: payload,
        };
      },
      // Transform response data
      transformResponse: (response) => {
        return StatsModel.jsonToModel(response);
      },
    }),

    // AFFILIATES
    getDashboardAffiliate: builder.query({
      query: (value) => {
        const payload = PayloadModel.modelToJson(value);
        return {
          url: "/partners",
          method: "GET",
          params: payload,
        };
      },
      transformResponse: (response) => {
        return AffiliatesModel.jsonToModel(response);
      },
    }),
    exportDashboardAffiliates: builder.query({
      query: (value) => {
        const payload = PayloadModel.modelToJson(value);
        return {
          url: "exports/partners",
          method: "GET",
          params: payload,
          responseHandler: (response) => response.blob(),
        };
      },
      transformResponse: (response) => {
        return response;
      },
    }),

    // PRODUCTS
    getDashboardProducts: builder.query({
      query: (value) => {
        const payload = PayloadModel.modelToJson(value);
        return {
          url: "/products",
          method: "GET",
          params: payload,
        };
      },
      transformResponse: (response) => {
        return ProductsModel.jsonToModel(response);
      },
    }),

    exportDashboardProducts: builder.query({
      query: (value) => {
        const payload = PayloadModel.modelToJson(value);
        return {
          url: "exports/products",
          method: "GET",
          params: payload,
          responseHandler: (response) => response.blob(),
        };
      },
      transformResponse: (response) => {
        return response;
      },
    }),
  }),
});

export const { useGetDashboardStatsQuery, useGetDashboardAffiliateQuery, useLazyExportDashboardAffiliatesQuery, useGetDashboardProductsQuery, useLazyExportDashboardProductsQuery } = dashboardApi;
